"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMPORT_FILE_ENTRIES_FINAL_STATUSES = void 0;
const enums_1 = require("../enums");
exports.IMPORT_FILE_ENTRIES_FINAL_STATUSES = [
    enums_1.importFileEntryStatuses.FAILED,
    enums_1.importFileEntryStatuses.IGNORED,
    enums_1.importFileEntryStatuses.SUCCESS,
];
